/**
 * Turns the `/chat/list-mine` response into the bulk-invite `Chats` tab's
 * list of chats the caller may invite out of (ISSUE-1097).
 *
 * A pool's own chat is left out: its roster is the pool's, and inviting out
 * of a pool is for its Commissioner and Admins (owner decision 2026-10-08),
 * which the `Pools` tab already enforces. A message request the fan has not
 * answered is left out too, the same filter `shareGame/shareChatLogic.ts`
 * applies. The order is the server's, newest activity first. messaging-api
 * re-checks all of this when the preview runs, so this list is a courtesy,
 * not the gate.
 */

export const INVITE_CHAT_LIST_LIMIT = 50;

export type typeInviteSourceChatInput = {
  chatId: string;
  chatType: "pool" | "private" | "standalone";
  title: string;
  isPendingApproval: boolean;
};

export type typeInviteSourceChatRow = {
  chatId: string;
  chatType: "private" | "standalone";
  title: string;
};

export type typeInviteSourceChatsState =
  | { phase: "loading" }
  | { phase: "failed" }
  | { phase: "empty" }
  | { phase: "ready"; rows: typeInviteSourceChatRow[] };

export function resolveInviteSourceChatsState(input: {
  isLoading: boolean;
  hasFailed: boolean;
  items: readonly typeInviteSourceChatInput[] | null;
}): typeInviteSourceChatsState {
  if (input.hasFailed) {
    return { phase: "failed" };
  }
  if (input.isLoading || input.items === null) {
    return { phase: "loading" };
  }

  const rows: typeInviteSourceChatRow[] = [];
  for (const item of input.items) {
    if (item.chatType === "pool" || item.isPendingApproval) {
      continue;
    }
    rows.push({
      chatId: item.chatId,
      chatType: item.chatType,
      title: item.title,
    });
  }

  if (rows.length === 0) {
    return { phase: "empty" };
  }
  return { phase: "ready", rows };
}

/** The source name the confirm headline reads, "Invite 2 people from ...?". */
export function inviteChatSourceName(row: typeInviteSourceChatRow): string {
  if (row.chatType === "private") {
    return `your chat with ${row.title}`;
  }
  return row.title;
}
